
document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll(
    '.article-builder__video video, ' +
    '.article-builder__media--video video, ' +
    '.featured-video video'
  );

  if (!videos.length) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        const video = entry.target;

        if (entry.isIntersecting && document.visibilityState === 'visible') {
          video.muted = true;

          const playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.catch(function () {
              // Browser may prevent autoplay.
            });
          }
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: 0.5
    }
  );

  videos.forEach(function (video) {
    video.muted = true;
    video.setAttribute('playsinline', '');
    observer.observe(video);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      videos.forEach(function (video) {
        video.pause();
      });
    }
  });
});
